import { useState, useCallback } from 'react';
import * as qs from 'query-string';

declare let window: any;

function replaceState(value: string) {
  if (value === '?') {
    value = '';
  }
  const url = window.location.protocol + '//' + window.location.host + window.location.pathname + value;
  window.history.replaceState({ path: url }, '', url);
}

function getQueryStringValue(key: string, queryString = window.location.search) {
  const values = qs.parse(queryString);
  return values[key];
}

function setQueryStringValue(key: string, value: any, queryString = window.location.search) {
  const values = qs.parse(queryString);

  if (!value) {
    delete values[key];
  } else {
    values[key] = value;
  }

  const newQsValue = qs.stringify(values);
  replaceState(`?${newQsValue}`);
}

export function useQueryString(key: any, initialValue: any) {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(
    (newValue: string) => {
      setValue(newValue);
      setQueryStringValue(key, newValue);
    },
    [key]
  );

  return [value, onSetValue];
}
